import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CitizensServicesDeliveryProcedureSteps} from './citizens-services-delivery-procedure-steps.model';
import * as CitizensServicesDeliveryProcedureStepsActions from './citizens-services-delivery-procedure-steps.actions';

export const citizensServicesDeliveryProcedureStepsesFeatureKey = 'citizensServicesDeliveryProcedureStepses';

export interface State extends EntityState<CitizensServicesDeliveryProcedureSteps> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CitizensServicesDeliveryProcedureSteps> = createEntityAdapter<CitizensServicesDeliveryProcedureSteps>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CitizensServicesDeliveryProcedureStepsActions.addCitizensServicesDeliveryProcedureSteps,
    (state, action) => adapter.addOne(action.citizensServicesDeliveryProcedureSteps, state)
  ),
  on(CitizensServicesDeliveryProcedureStepsActions.upsertCitizensServicesDeliveryProcedureSteps,
    (state, action) => adapter.upsertOne(action.citizensServicesDeliveryProcedureSteps, state)
  ),
  on(CitizensServicesDeliveryProcedureStepsActions.addCitizensServicesDeliveryProcedureStepss,
    (state, action) => adapter.addMany(action.citizensServicesDeliveryProcedureStepss, state)
  ),
  on(CitizensServicesDeliveryProcedureStepsActions.upsertCitizensServicesDeliveryProcedureStepss,
    (state, action) => adapter.upsertMany(action.citizensServicesDeliveryProcedureStepss, state)
  ),
  on(CitizensServicesDeliveryProcedureStepsActions.updateCitizensServicesDeliveryProcedureSteps,
    (state, action) => adapter.updateOne(action.citizensServicesDeliveryProcedureSteps, state)
  ),
  on(CitizensServicesDeliveryProcedureStepsActions.updateCitizensServicesDeliveryProcedureStepss,
    (state, action) => adapter.updateMany(action.citizensServicesDeliveryProcedureStepss, state)
  ),
  on(CitizensServicesDeliveryProcedureStepsActions.deleteCitizensServicesDeliveryProcedureSteps,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CitizensServicesDeliveryProcedureStepsActions.deleteCitizensServicesDeliveryProcedureStepss,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CitizensServicesDeliveryProcedureStepsActions.loadCitizensServicesDeliveryProcedureStepss,
    (state, action) => adapter.setAll(action.citizensServicesDeliveryProcedureStepss, state)
  ),
  on(CitizensServicesDeliveryProcedureStepsActions.clearCitizensServicesDeliveryProcedureStepss,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
